import { ImageFieldImage } from '@prismicio/client';
import { Image } from 'interfaces';

export const prismicToImage = (raw: ImageFieldImage) => {
  return new Image(raw.url, raw.dimensions, raw.alt, raw.copyright);
};
